<template>
  <pp-button
    :class="{'radial-pulsating-animation': !isWidgetOpen}"
    :icon="isWidgetOpen ? 'chevron-down' : 'chat'"
    class="chat-button pa-8 text-h2 white--text d-flex ml-auto"
    type="primary"
    @click="showWidgetList"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { WIDGET_CLICKED_SESSION_KEY } from '@/constants'

export default {
  name: 'ChatButton',
  computed: {
    ...mapGetters({
      isWidgetOpen: 'isWidgetOpen'
    })
  },
  methods: {
    ...mapMutations({
      setIsWidgetOpen: 'SET_IS_WIDGET_OPEN'
    }),
    trackShowWidgetList () {
      this.$ppAnalytics.trackEvent({
        action: 'multi_channel_list_open'
      })
    },
    showWidgetList () {
      this.$emit('showWidgetListEvent')
      sessionStorage.setItem(WIDGET_CLICKED_SESSION_KEY, true)
      this.trackShowWidgetList()
      this.setIsWidgetOpen(!this.isWidgetOpen)
    }
  }
}
</script>
<style lang="scss" scoped>
$animation-height-width: 100%;

.radial-pulsating-animation {
  &:before,
  &:after {
    animation: scaleIn 2.5s infinite cubic-bezier(0, 0, 0, 0);
    background-color: var(--pp-theme-color);
    border-radius: 50%;
    content: '';
    height: $animation-height-width;
    opacity: 0;
    position: absolute;
    width: $animation-height-width;
  }

  &:before {
    animation-delay: 1.5s;
  }

  &:after {
    animation-delay: 2s;
    z-index: -10;
  }
}

@keyframes scaleIn {
  from {
    opacity: .6;
    transform: scale(.8, .8);
  }

  to {
    opacity: 0;
    transform: scale(1.5, 1.5);
  }
}
</style>
